(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aside-cart-backup-2026"]) return;
  try {
    
  const other_products_cart = document.getElementById('other_products_cart');

    const otherProductsCartCarouselSettings = {
        type: 'slide',
        rewind: false,
        autoHeight: false, 
        perPage: 1,
        start: 0,
        autoplay: false,
        interval: 3200,
        speed: 600,
        pauseOnHover: true,
        gap: 24,
        arrows: true,
        trimSpace: true,
        pagination : false,
    }

    const otherProductsCartCarousel = new Splide(other_products_cart, otherProductsCartCarouselSettings);
    otherProductsCartCarousel.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aside-cart"]) return;
  try {
    
  const other_products_cart = document.getElementById('other_products_cart');

  const otherProductsCartCarouselSettings = {
    type: 'slide',
    rewind: false,
    autoHeight: false,
    perPage: 1,
    start: 0,
    autoplay: false,
    interval: 3200,
    speed: 600,
    pauseOnHover: true,
    gap: 24,
    arrows: true,
    trimSpace: true,
    pagination : false,
  }

  const otherProductsCartCarousel = new Splide(other_products_cart, otherProductsCartCarouselSettings);
  otherProductsCartCarousel.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-circle-group"] && !Shopify.designMode) return;
  try {
    

const initGsap = ( accordion ) => {
    items = accordion.querySelectorAll('.ac');
    items.forEach((item, index) => { 
        if( index % 2 == 0 ) {
            gsap.from(item, {
            y: '100%',
            opacity: 0, 
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: item,
              start: "top 100%", 
              toggleActions: "play none none none",
            },
          });
        }
        else {
          gsap.from(item, {
            y: '100%',
            opacity: 0, // Start opacity
            duration: 1, // Animation duration
            ease: "power2.out",
            scrollTrigger: {
              trigger: item, // Trigger the animation when this element enters
              start: "top 100%", // When the top of box reaches 80% of viewport height
              toggleActions: "play none none none", // Play only once
            },
          });
        }      
    });
  }    


  const accords = document.querySelectorAll('.faq-ac');
  accords.forEach( item => {
    new Accordion( item , {
      showMultiple: false,
    });

    if (item != accords[0]) {
      initGsap( item );
    }
  })





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const header_products_select = document.getElementById('header_products_select');
      const header_products_selected_title = document.getElementById('header_products_selected_title');
      const header_products_selected_compare_price = document.getElementById('header_products_selected_compare_price');
      const header_products_selected_price = document.getElementById('header_products_selected_price');
      const header_products_button = document.getElementById('header_products_button');
      const header_products_button_price = header_products_button?.querySelector('.button-price');

      const header_products_checkbox = document.getElementById('header_products_checkbox');
      const header_products_items = document.querySelectorAll('.header-products-item');

  
    header_products_items.forEach(item => {
      item.addEventListener('click', () => {

        header_products_items.forEach(i => {
          i.classList.remove('header-product-selected');
        });
        item.classList.add('header-product-selected');
        header_products_selected_title.textContent = item.querySelector('#header_products_select_title')?.textContent;
        header_products_selected_compare_price.textContent = item.querySelector('#header_products_select_compare_price')?.textContent;
        header_products_selected_price.textContent = item.querySelector('#header_products_select_price')?.textContent;
        header_products_button_price.textContent = ' - ' + item.querySelector('#header_products_select_price')?.textContent;
        header_products_button.dataset.quantity = item.dataset.quantity;
        header_products_checkbox.checked = false;
      });
    });

    });

    new Splide('#info_bar_splide', {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 3,
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: .2,
      },
  }).mount( window.splide.Extensions );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-custom-reviews"] && !Shopify.designMode) return;
  try {
    

document.addEventListener( 'DOMContentLoaded', function() {

    const splideReviews = new Splide( '.splide-reviews', {
      perPage: 4,
      gap: 20,
      type: 'loop',
      pagination: false,
      speed: 860,
      arrows: false,
      drag: 'free',
      focus: 'center',
      autoScroll: {
          speed: 0.15,
          pauseOnHover: true,
      },


      breakpoints: {
        1024: {
          type: 'loop',
          perPage: 2,
          padding: { right: 90 }
        },
        640: {
          perPage: 1,
          padding: { right: 70 }
        },
      }
  });

  splideReviews.mount(window.splide.Extensions);


});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-group"] && !Shopify.designMode) return;
  try {
    

const initGsap = ( accordion ) => {
    items = accordion.querySelectorAll('.ac');
    items.forEach((item, index) => {
        if( index % 2 == 0 ) {
            gsap.from(item, {
            y: '100%',
            opacity: 0, 
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: item,
              start: "top 100%", 
              toggleActions: "play none none none",
            },
          });
        }
        else {
          gsap.from(item, {
            y: '100%',
            opacity: 0, // Start opacity
            duration: 1, // Animation duration
            ease: "power2.out",
            scrollTrigger: {
              trigger: item, // Trigger the animation when this element enters
              start: "top 100%", // When the top of box reaches 80% of viewport height
              toggleActions: "play none none none", // Play only once
            },
          });
        }
    });
  }    

  const accords = document.querySelectorAll('.faq-ac');
  accords.forEach( item => {
    new Accordion( item , {
      showMultiple: false,
    });

    initGsap( item );
  })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-image-group"] && !Shopify.designMode) return;
  try {
    


const mm = gsap.matchMedia();


const initGsap = ( accordion ) => {
    items = accordion.querySelectorAll('.ac');
    items.forEach((item, index) => {
        if( index % 2 == 0 ) {

        mm.add({
            isMobile: "(max-width: 1024px)",
            isDesktop: "(min-width: 1024px)"
          }, (context) => {
            let { isMobile } = context.conditions;
            gsap.from(item, {
              y: isMobile ? '10%' : '100%',
              opacity: 0, 
              duration: 1,
              ease: "power2.out",
              scrollTrigger: {
                trigger: item,
                start: "top 100%", 
                toggleActions: "play none none none",
              },
            });
        }) 
        }
        else {
          mm.add({
            isMobile: "(max-width: 1024px)",
            isDesktop: "(min-width: 1024px)"
          }, (context) => {
            let { isMobile } = context.conditions;
              gsap.from(item, {
                y: isMobile ? '10%' : '100%',
                opacity: 0, // Start opacity
                duration: 1, // Animation duration
                ease: "power2.out",
                scrollTrigger: {
                  trigger: item, // Trigger the animation when this element enters
                  start: "top 100%", // When the top of box reaches 80% of viewport height
                  toggleActions: "play none none none", // Play only once
                },
              });
            })
        }
    });
  }    
  

  const accords = document.querySelectorAll('.faq-ac');
  accords.forEach( item => {
    new Accordion( item , {
      showMultiple: false,
    });

    initGsap( item );
  })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ingredients-carousel"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener( 'DOMContentLoaded', function() {
   
    const primary = new Splide( '.splide-ingredients-thumbnail', {
      type: 'loop',
      autoHeight: true,
      perPage: 5,
      perMove: 1,
      focus: 'center',
      pagination: false,
      gap: 0,
      padding: 0,
      isNavigation: true,
      breakpoints: {
        1024: {
          perPage: 3,
        },
        600: {
          perPage: 1,
        },
      }
    } );

    const secondary = new Splide( '.splide-ingredients-description', {
      type: 'fade',
      autoHeight: true, 
      perPage: 1,
      perMove: 1,
      focus: 'center',
      pagination: false,
      arrows: false,
      gap: 65,
      breakpoints: {
        600: {
          perPage: 1,
          autoHeight: false
        },
      }
    } );

    const slides = document.querySelectorAll('.splide-ingredients-thumbnail .splide__slide');
    const activeClass = "custom-active";
    slides[0].classList.add(activeClass);
    
    secondary.mount();
    primary.sync( secondary );
    primary.mount();
    

    primary.on('move', function (newIndex, oldIndex) {          
        // Remove the class from the old slide
        if (slides[oldIndex]) {
            slides[oldIndex].classList.remove(activeClass);
        }

        // Add the class to the new slide
        if (slides[newIndex]) {
            slides[newIndex].classList.add(activeClass);
        }
    });
    
  } );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-benefits"] && !Shopify.designMode) return;
  try {
    
    new Accordion('.home-benefits-ac', {
      showMultiple: false,
    });


    const paginationWrapper = document.querySelector('.pagination-interval');
    const splideInterval = 5000;

    document.addEventListener( 'DOMContentLoaded', function() {
      const primary = new Splide( '.splide-photos', {
      type: 'loop',
      autoHeight: true,
      perPage: 1,
      autoplay: true,
      perMove: 1,
      interval: splideInterval,
      pagination: 'splide__pagination',
      arrows: false,
      gap: '1rem',
      });      

      const gsapAnimation = gsap.to(paginationWrapper, {
          duration: splideInterval/1000,
          '--after-width-benefits': '100%',
          ease: 'power1.inOut'
        });

        primary.on( 'autoplay:play', function ( rate ) {  
          gsapAnimation.play();      
        } );

      primary.on( 'move', function () {  
        gsapAnimation.progress(0).play();
      } );

      primary.mount();

    });

   


  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-bottle"] && !Shopify.designMode) return;
  try {
     
  gsap.registerPlugin(ScrollTrigger);
  const benefitItems = document.querySelectorAll(".benefit-item");

  const mm = gsap.matchMedia();

  mm.add({
    isMobile: "(max-width: 1024px)",
    isDesktop: "(min-width: 1024px)"
  }, (context) => {
    let { isMobile } = context.conditions;

    benefitItems.forEach((item) => {
      if( [...item.classList].includes('benefit-item-left') ) {
          gsap.from(item, {
          x: isMobile ? '100%' : '-100%',
          opacity: 0, 
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: item,
            start: "top 80%", 
            toggleActions: "play none none none",
          },
        });
      }
      else {
        gsap.from(item, {
          x: '100%',
          opacity: 0, // Start opacity
          duration: 1, // Animation duration
          ease: "power2.out",
          scrollTrigger: {
            trigger: item, // Trigger the animation when this element enters
            start: "top 80%", // When the top of box reaches 80% of viewport height
            toggleActions: "play none none none", // Play only once
          },
        });
      }
    });
  })

        gsap.from('.bottle', {
          opacity: 0,
          duration: 2, 
          ease: "power2.out",
          scrollTrigger: {
            trigger: '.bottle',
            start: "top 100%",
            toggleActions: "play none none none", 
          },
        });



  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-home-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll('.home-faq-ac');
    accordions.forEach(accordion => {
      new Accordion(accordion, {
        showMultiple: false,
      });
    });
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-home-reviews"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener( 'DOMContentLoaded', function() {

    const splideInterval = 5000;
    const splide = new Splide( '.splide-reviews', {
      type: 'loop',
      autoHeight: true,
      perPage: 3,
      perMove: 1,
      autoplay: true,
      interval: splideInterval,
      focus: 0,
      gap: 24,
      pagination: 'splide__pagination',
      breakpoints: {
        1024: {
          autoHeight: true,
          perPage: 1,
          arrows: false,
        },
      }
    } );

    const paginationWrapper = document.querySelector('.pagination-interval-reviews');
    const gsapAnimation = gsap.to(paginationWrapper, {
        duration: splideInterval/1000,
        '--after-width': '100%',
        ease: 'power1.inOut'
      });

      splide.on( 'autoplay:play', function ( rate ) {  
        gsapAnimation.play();      
      } );

    splide.on( 'move', function () {  
      gsapAnimation.progress(0).play();
    } );

    splide.mount({});
  } );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-results"] && !Shopify.designMode) return;
  try {
    
  

  window.addEventListener("load", (event) => {
    const counterElements = document.querySelectorAll(".item-result");
    

    counterElements.forEach(element => {
    const target = element.getAttribute('attr-target');
    const targetNumber = parseInt(target.match(/\d+/)[0], 10);
    const targetAppend = target.replace(targetNumber, "").trim();

      const gsapCount = gsap.to({ value: 0 }, {
        value: targetNumber, // Target number
        duration: 2, // Duration of the animation
        ease: "sine.in",
        scrollTrigger: {
            trigger: element,
            start: "top 110%",
            toggleActions: "play none none none", 
          },
        onUpdate: function () {
          // Update the counter element with the rounded current value
          element.textContent = `${Math.floor(this.targets()[0].value)}${targetAppend}`;
        },
        onComplete: function () {
          // Ensure the final value is exactly the target number
          element.textContent = `${targetNumber}${targetAppend}`;
        }
      });

    });
  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-section-stats"] && !Shopify.designMode) return;
  try {
    
  

  window.addEventListener("load", (event) => {
    const counterElements = document.querySelectorAll(".item-result");
    
   counterElements.forEach(element => {
        const target = element.getAttribute('attr-target');

        // Získa číslo (aj s desatinami)
        const numberMatch = target.match(/[\d.]+/);
        if (!numberMatch) return;

        const targetNumber = parseFloat(numberMatch[0]);

        // Zistí počet desatinných miest
        const decimals = (numberMatch[0].split('.')[1] || '').length;

        // Zvyšok (%, jednotky...)
        const targetAppend = target.replace(numberMatch[0], '').trim();

        gsap.to({ value: 0 }, {
          value: targetNumber,
          duration: 2,
          ease: "sine.in",
          scrollTrigger: {
            trigger: element,
            start: "top 110%",
            toggleActions: "play none none none",
          },
          onUpdate: function () {
            const v = this.targets()[0].value;
            element.textContent =
              `${v.toFixed(decimals)}${targetAppend}`;
          },
          onComplete: function () {
            element.textContent =
              `${targetNumber.toFixed(decimals)}${targetAppend}`;
          }
        });
      });
  });


  document.addEventListener('DOMContentLoaded', function () {

   const stats_carousel = document.getElementById('stats_carousel');

    const statsCarouselSettings = {
      perPage: 3,
      gap: 20,
      type: 'loop',
      pagination: false,
      speed: 860,
      arrows: false,
      drag: 'free',
      focus: 'center',
      autoScroll: {
        speed: 0.2,
        pauseOnHover: false,
      },
      breakpoints: {
        400: {
          perPage: 2,
        },
      }
    }

    const statsCarousel = new Splide(stats_carousel, statsCarouselSettings);
    statsCarousel.mount(window.splide.Extensions);

  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-user-gallery"] && !Shopify.designMode) return;
  try {
    

document.addEventListener( 'DOMContentLoaded', function() {

    const splideImages = new Splide( '.splide-images', {
      type: 'loop',
      perPage: 5,
      perMove: 1,
      gap: 20,
      pagination: false,
      arrows: false,
      drag: 'free',
      focus: 'center',
      speed: 860,
      autoScroll: {
          speed: 0.15,
          pauseOnHover: true,
      },
      breakpoints: {
        1024: {
          type: 'loop',
          perPage: 2,
          padding: { right: 90 }
        },
        640: {
          perPage: 1,
          padding: { right: 70 }
        },
      }
  });

  splideImages.mount(window.splide.Extensions);


});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-user-videos"] && !Shopify.designMode) return;
  try {
    

document.addEventListener( 'DOMContentLoaded', function() {

    const splideVideos = new Splide( '.splide-videos', {
      type: 'slide',
      perPage: 5,
      perMove: 1,
      
      autoplay: false,
      pagination: false,
      arrows: false,
      gap: 20,
      breakpoints: {
        1024: {
          type: 'loop',
          perPage: 2,
          padding: { right: 90 }
        },
        640: {
          perPage: 1,
          padding: { right: 70 }
        },
      }
  });

  splideVideos.mount({});

  const videoOverlays = document.querySelectorAll('.section-videos .video-overlay');
  const allVideos = document.querySelectorAll('.section-videos video');
  splideVideos.on('moved', function() {
    allVideos.forEach((video, index) => {
      video.pause();
    });
  });

  allVideos.forEach((video, indexCurrent) => {
    video.classList.add('hide-controls');
    video.addEventListener('pause', () => {
      videoOverlays[indexCurrent].classList.remove('hidden');
      video.classList.add('hide-controls');
    })
    video.addEventListener('play', () => {
      videoOverlays[indexCurrent].classList.add('hidden');
      video.classList.remove('hide-controls');
      allVideos.forEach((otherVideo, indexOther) => {
        if (otherVideo !== video && !otherVideo.paused) {
          otherVideo.pause();
        }
      });
    });
  });

});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-needs"] && !Shopify.designMode) return;
  try {
    

document.addEventListener( 'DOMContentLoaded', function() {

    const splideNeeds = new Splide( '.splide-section-needs', {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      
      autoplay: false,
      pagination: false,
      arrows: false,
      // focus: 'center',
      gap: 20,
      breakpoints: {
        1024: {
          type: 'slide',
          perPage: 2.2,
          gap: 10, 
          focus: 'center'
          // padding: { right: 90 }
        },
        640: {
          perPage: 1.25,
          // padding: { right: 70 }
        },
      }
  });

  splideNeeds.mount({});


});

// const showOverlay = ( video ) => {
//   console.log( video );
// }


  } catch(e) { console.error(e); }
})();
})();
